import { useTranslation as useI18nTranslation } from 'react-i18next';
import { Language } from '../types';
import { TranslationType } from '../translations/types';

export interface TranslationHook {
  currentLanguage: Language;
  t: TranslationType;
  changeLanguage: (lang: Language) => Promise<void>;
}

export const useTranslation = (): TranslationHook => {
  const { t: translate, i18n } = useI18nTranslation();

  const currentLanguage = i18n.language === 'fr' ? Language.FR : Language.EN;

  const changeLanguage = async (lang: Language) => {
    try {
      const language = lang.toLowerCase();
      await i18n.changeLanguage(language);
      localStorage.setItem('language', language);
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  const t = new Proxy({} as TranslationType, {
    get: (target, prop: string) => {
      if (typeof prop === 'string') {
        const sections = ['home', 'media', 'navigation', 'auth', 'profile', 'blog', 'common', 'search', 'footer'];
        if (sections.includes(prop)) {
          return new Proxy({}, {
            get: (_, nestedProp: string) => translate(`${prop}.${nestedProp}`)
          });
        }
        return translate(prop);
      }
      return undefined;
    }
  });

  return {
    currentLanguage,
    t,
    changeLanguage
  };
};
